import { useRouter } from 'next/router'
import { useEffectOnce } from 'react-use'

import useResetQueryStrings from '@web/hooks/useResetQueryStrings'
import { reviewTabFilterStateVar } from '@web/pages/[objectId]/review/components/ReviewTab/filter.state'
import { extractMediaQuery, extractSortQuery } from '@web/pages/[objectId]/review/components/ReviewTab/ReviewTab.helper'

export const useSetReviewTabFilterOnInit = () => {
  const router = useRouter()
  const resetQueryStrings = useResetQueryStrings()
  const mediaQuery = extractMediaQuery(router.query.media)
  const sortQuery = extractSortQuery(router.query.sort)

  if (sortQuery) reviewTabFilterStateVar.sort(sortQuery)

  if (mediaQuery) reviewTabFilterStateVar.mediaFilter(mediaQuery)

  useEffectOnce(() => {
    resetQueryStrings(['media', 'sort'])
  })
}
